import { render, staticRenderFns } from "./HistoryPanel.vue?vue&type=template&id=4bfd928a&scoped=true&"
import script from "./HistoryPanel.vue?vue&type=script&lang=ts&"
export * from "./HistoryPanel.vue?vue&type=script&lang=ts&"
import style0 from "./HistoryPanel.vue?vue&type=style&index=0&id=4bfd928a&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfd928a",
  null
  
)

export default component.exports